import {useMutation, UseMutationResult, useQueryClient} from '@tanstack/react-query';
import {clientVersionsApi} from '../api';
import {useNotifications} from '../../../shared';

type UseClientVersionByIdResult = {
  deleteClientVersionMutation: UseMutationResult<void, Error, string>;
};

export const useClientVersionById = (): UseClientVersionByIdResult => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const deleteClientVersionMutation = useMutation({
    mutationFn: (clientVersionId: string) => clientVersionsApi.deleteClientVersion(clientVersionId),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['client-versions']});
      createNotification({
        title: 'Версия приложения успешно удалена',
        name: 'deleteClientVersion',
        theme: 'success',
      });
    },
  });

  return {
    deleteClientVersionMutation,
  };
};

